export const cleanLocalStorage = () => {
  const token: string = localStorage.getItem("token");
  localStorage.clear();
  localStorage.setItem("token", token);
};
